<template>
  <div class="unicode-tool">
    <div class="input-container">
      <div class="input-group left">
        <label for="dataInput">Input:</label>
        <textarea
          id="dataInput"
          v-model="dataInput"
          placeholder="Enter text here..."
          rows="10"
        ></textarea>
      </div>
      <div class="input-group right">
        <label for="dataOutput">Output:</label>
        <textarea
          id="dataOutput"
          v-model="dataOutput"
          placeholder=""
          rows="10"
          readonly
        ></textarea>
      </div>
    </div>
    <div class="button-container">
      <button @click="clearAll">Clear All</button>
      <button @click="convertTextToUnicode">Text to Unicode</button>
      <button @click="convertUnicodeToText">Unicode to Text</button>
      <button @click="copyOutput">Copy Output</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataInput: '',
      dataOutput: ''
    };
  },
  methods: {
    convertTextToUnicode() {
      this.dataOutput = this.dataInput
        .split('')
        .map(char => `\\u${char.charCodeAt(0).toString(16).padStart(4, '0')}`)
        .join('');
    },
    convertUnicodeToText() {
      // 将 Unicode 字符串转换为文本
      const unicodePattern = /\\u([0-9A-Fa-f]{4})/g;
      let match;
      let result = '';
      while ((match = unicodePattern.exec(this.dataInput)) !== null) {
        result += String.fromCharCode(parseInt(match[1], 16));
      }
      this.dataOutput = result;
    },
    clearAll() {
      this.dataInput = '';
      this.dataOutput = '';
    },
    copyOutput() {
      if (this.dataOutput) {
        navigator.clipboard.writeText(this.dataOutput)
          .then(() => {
            alert('Output copied to clipboard!');
          })
          .catch(err => {
            console.error('Failed to copy output: ', err);
            alert('Failed to copy output.');
          });
      }
    }
  }
};
</script>

<style scoped>
.unicode-tool {
  width: 100%;
  height: 70vh; /* 确保组件充满整个视口高度 */
  margin: 0;
  padding: 15px 0px;
  display: flex;
  flex-direction: column;
}

.input-container {
  flex: 1; /* 使输入容器充满剩余空间 */
  display: flex;
  justify-content: space-between;
}

.input-group {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.input-group.left {
  margin-right: 5px; /* 添加右侧间距 */
}

.input-group.right {
  margin-left: 5px; /* 添加左侧间距 */
}

.input-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: light;
}

textarea {
  flex: 1; /* 使 textarea 充满剩余空间 */
  margin-top: 5px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical;
}

textarea[readonly] {
  background-color: #f9f9f9;
  color: #333;
}

.button-container {
  text-align: center;
  margin-top: 20px;
}

button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s;
  margin: 0 5px;
}

button:hover {
  background-color: #0056b3;
}
</style>